// extracted by css-extract-rspack-plugin
export default {"pwd":"KEueHw"};